import React from 'react'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'
import Input from './Input'

import Grid from '@material-ui/core/Grid'

import Title from './Title'

import { FlagIcon } from "react-flag-kit";

import './Traduction.css'

import ApiRequest from 'EurestoApi/ApiRequest'
import Wysiwyg from 'Components/Wysiwyg'

const project = require('EurestoConfig/project.config')

class Traduction extends React.Component {
  constructor(props) {
    super(props)

    console.log('Reconstructe this')

    const texts = props.data || []

    const langs = User.User.get().saisie_langue_defaut && (User.User.get().langue_id && [{ libelle: 'Default', id: 1 }] || [{ libelle: 'Français', id: 1 }]) || User.User.get().langs || Data.list(Constants.module.COMMUN, Constants.donnee.langue, { traduction: 1 }).filter(langue => EurestoLangue(langue.id))
    const langSelected = ((langs || []).find(l => l.id === User.User.get().langue_id) || {}).id || (langs[0] || {}).id || 1

    this.state =
    {
      texts: texts,
      langs: langs && langs.length > 0 && langs || Data.list(Constants.module.COMMUN, Constants.donnee.langue, { id: 1 }) || [{ libelle: 'Français', id: 1 }],
      type: props.type !== undefined ? props.type : Constants.typeSaisie.SaisieLibre,
      height: props.height || '200px',
      width: props.width !== undefined ? props.width : '100%',
      langSelected: langSelected || -1,
      name: props.name,
      title: props.title !== undefined ? props.title : '',
      focus: props.focus !== undefined ? props.focus : false,
      readOnly: props.readOnly !== undefined ? props.readOnly : false,
      disabled: props.disabled !== undefined ? props.disabled : false,
    }
    if (User.User.get().saisie_langue_defaut === 0 || User.User.get().saisie_langue_defaut === '0' || User.User.get().saisie_langue_defaut === undefined) {
      Data.addCbRestate(Constants.module.CONFIGURATION, Constants.donnee.langue, this.restate)
    }
  }

  restate = () => {
    this.forceUpdate()
  }

  apiSend = async (file, base64) => {
    let jsonGet = {
      requete: 'upload',
      action: 'add',
      type_fichier: file.type,
      base64: base64,
      libelle: file.name,
      contact_id: this.props.client_id || '',
      type_media_id: this.props.typeFichier && this.props.typeFichier.id || 99,
      action_id: this.state.action_id || ''
    }

    const result = await ApiRequest(project.api + 'upload', jsonGet)
    return (result || {}).lien
  }

  onChangeInput(value, langue_id) {
    let newTexts = this.state.texts || []
    let pos = newTexts.findIndex(text => text.langue_id === parseInt(langue_id))
    if (pos !== -1) {
      newTexts[pos].text = value
      this.setState({
        texts: newTexts
      }, () => this.props.onChange(newTexts, this.props.name))
    } else {
      newTexts.push({ text: value, langue_id: parseInt(langue_id) })
      this.setState({
        texts: newTexts
      }, () => this.props.onChange(newTexts, this.props.name))
    }
  }

  onChange(name) {
    return (value) => {
      let newTexts = this.state.texts || []
      let pos = newTexts.findIndex(text => text.langue_id === parseInt(name))
      if (pos !== -1) {
        newTexts[pos].text = value
        this.setState({
          texts: newTexts
        }, () => this.props.onChange(newTexts, this.props.name))
      } else {
        newTexts.push({ text: value, langue_id: parseInt(name) })
        this.setState({
          texts: newTexts
        }, () => this.props.onChange(newTexts, this.props.name))
      }
    }
  }

  onChangeWysiwyg = (name) => (data) => {
    let newTexts = this.state.texts
    let pos = newTexts.findIndex(text => text.langue_id === parseInt(name))
    if (pos !== -1) {
      newTexts[pos].text = data
      this.setState({
        texts: newTexts
      }, () => this.props.onChange(newTexts, this.props.name))
    } else {
      newTexts.push({ text: data, langue_id: parseInt(name) })
      this.setState({
        texts: newTexts
      }, () => this.props.onChange(newTexts, this.props.name))
    }
  }

  handleFlag = (value) => {
    this.setState({
      langSelected: value,
    })
    this.textInput && this.textInput.focus()
  }
  componentDidMount() {
    if (this.textInput && this.state.focus === true) {
      this.textInput.focus()
    }
  }

  render() {
    if (this.state.type === Constants.typeSaisie.SaisieLibre) {
      return (
        this.state.langs.map((lang, index) => {
          let posText = (this.state.texts || []).findIndex(text => (text.langue_id === lang.id))
          if (User.User.get().saisie_langue_defaut && this.state.langs.length === 1 && posText === -1 && this.state.texts.length > 0) {
            posText = 0
          }
          return (
            <div key={'div-' + index} style={{ display: 'block' }}>
              <Input
                placeholder={index === 0 && this.props.placeholder || undefined}
                InputStyle={this.props.InputStyle}
                inputStyle={this.props.inputStyle}
                inlineWidth={this.props.inlineWidth}
                autoFocus={index === 0 && this.props.autoFocus}
                style={{ ...(this.props.style || {}) }}
                inline={this.props.inline}
                multi={this.props.multi}
                rowsMax={this.props.rowsMax}
                rows={this.props.rows}
                title={this.props.title && <span>
                  {!User.User.get().saisie_langue_defaut && this.state.langs.length > 1 &&
                    <FlagIcon style={{ marginRight: 5, marginBottom: 1.5 }}
                      code={lang.code_alpha2 && lang.code_alpha2.toUpperCase()}
                      size={15} />}
                  {this.props.title}</span>}
                disabled={this.props.disabled || false}
                key={'input-' + index}
                type='text'
                onChange={(value) => this.onChangeInput(value, (this.state.texts[posText] || {}).langue_id || lang.id)}
                value={posText !== -1 ? this.state.texts[posText].text : ''} />
            </div>
          )
        })

      )
    } else {
      let posSelectedtext = (this.state.texts || []).findIndex(text => (text.langue_id === this.state.langSelected))
      return (
        <Title inline={this.props.inline} title={this.props.title}>
          <Grid container style={{ margin: 0, padding: 0 }} spacing={0}>
            {!User.User.get().saisie_langue_defaut && this.state.langs && this.state.langs.length > 1 &&
              <Grid item style={{ margin: 0, padding: 0, width: '50px' }}>
                <Grid container style={{
                  margin: 0,
                  padding: 2.5,
                  border: '1px solid #bbb',
                  borderTopLeftRadius: '10px',
                  borderBottomLeftRadius: '10px',
                  borderRight: 0,
                  backgroundColor: '#eee',
                  height: 'calc(100% - 2px)'
                }} spacing={0} alignItems={'stretch'} justify={'center'}
                  direction={'column'}>
                  {
                    this.state.langs.map((lang, index) => {
                      let posText = (this.state.texts || []).findIndex(text => (text.langue_id === lang.id))
                      return (
                        <Grid item style={{ margin: 0, padding: 0 }}>
                          <Grid container style={{ margin: 0, padding: 0 }} spacing={0}
                            onClick={() => this.handleFlag(lang.id)} style={{ cursor: 'pointer' }}>
                            <Grid item style={{ margin: 0, padding: 0 }} xs>
                              <i key={'div-' + index}
                                style={{
                                  display: 'inline',
                                  fontSize: lang.id === this.state.langSelected ? '16px' : '10px'
                                }}
                                className={'ei-commun_modifier ' +
                                  (posText !== -1 && (this.state.texts[posText].text !== '' && this.state.texts[posText].text !== '<p><br/></p>') ? 'text-success' : 'text-danger')} />
                              <FlagIcon code={lang.code_alpha2.toUpperCase()}
                                size={lang.id === this.state.langSelected ? 25 : 20} />
                            </Grid>
                          </Grid>
                        </Grid>
                      )
                    })
                  }
                </Grid>
              </Grid>}
            <Grid item style={{ margin: 0, padding: 0 }} xs>
              {
                this.state.type === Constants.typeSaisie.TextArea
                  ? <Input
                    multi
                    ref={(input) => {
                      this.textInput = input
                    }}
                    placeholder={this.props.placeholder}
                    inputStyle={this.props.inputStyle}
                    InputProps={this.props.InputProps}
                    inputProps={this.props.inputProps}
                    key={this.textInput}
                    disabled={this.props.disabled}
                    onChange={this.onChange(this.state.langSelected)}
                    style={{
                      height: this.state.height,
                      width: this.state.width,
                      minHeight: (25 * this.state.langs.length),
                      overflow: 'auto', maxHeight: this.props.maxHeight || this.props.height, ...(this.props.style || {})
                    }}
                    value={posSelectedtext !== -1 ? this.state.texts[posSelectedtext].text : ''} />
                  : this.state.type === Constants.typeSaisie.Wysiwyg
                    ?
                    <Wysiwyg
                      focus={true}
                      placeholder={this.props.placeholder}
                      key={this.state.langSelected + '_' + this.props.disabled}
                      onChange={this.onChangeWysiwyg(this.state.langSelected)}
                      maxHeight={this.state.height}
                      name='corps'
                      disabled={this.props.disabled}
                      value={posSelectedtext !== -1 ? this.state.texts[posSelectedtext].text : ''} />
                    : <div>AUCUNE OPTION POSSIBLE DÉFINI POUR LE CHAMP TRADUCTION</div>
              }
            </Grid>
          </Grid>
        </Title>
      )
    }
  }
}

export default Traduction



// WEBPACK FOOTER //
// ./app/Components/Traduction.js